module.exports = __webpack_public_path__ + "static/media/EP-tausta.508c3fa5.jpg";